import { UiColors } from 'assets/styles/old/global';
import styled, { css } from 'styled-components';
import { Button } from 'ui-kit';
import { DEVICES } from '_constants';

export const ModalWrapper = styled.div`
  min-height: 200px;
  min-width: 400px;
`;

export const CompactModalWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  max-width: 420px;

  @media ${DEVICES.mobileXL} {
    max-width: 100%;
  }
`;

export const ModalTitle = styled.h1`
  font-size: 20px;
  line-height: 1.6;
  font-weight: 500;
  text-align: center;
  margin-bottom: 17px;
  color: ${UiColors.forestColor};
`;

export const ModalDescription = styled.ul`
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
  text-align: left;
  margin-bottom: 26px;
  /* Inherits the frame's --modal-text (forest in the new design, dark in the legacy one). */
  color: inherit;
`;

// Consequence lines of ConfirmActionModal — shown as a bulleted list (the global reset drops markers).
export const ModalTips = styled.li`
  list-style: disc;
  margin-left: 20px;

  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

export const ModalButtonWrapper = styled.div`
  display: flex;
  align-items: baseline;
  flex-flow: row nowrap;

  button:not(:last-child) {
    margin-right: 10px;
  }
`;

const ModalButton = styled(Button)`
  font-size: 14px;
  line-height: 1.2;
  /* $variantColors keeps the variant's own text colour (Dark: peach, Danger:
     dark teal) instead of forcing white. */
  ${({ $variantColors }) =>
    !$variantColors &&
    css`
      color: var(--white);
    `}
  min-width: 135px;

  @media ${DEVICES.tablet} {
    padding: 0;

    > span {
      padding: 0 10px;
    }
  }
`;

export const ModalButtonCancel = styled(ModalButton)`
  min-width: 135px;

  @media ${DEVICES.mobileM} {
    min-width: 90px;

    > span {
      padding: 0 5px;
    }
  }
`;

export const ModalButtonSet = styled(ModalButton)``;

export const SelectWrapper = styled.div`
  margin: 20px 0;
`;
